export default {
  name: 'ProductListItem',
  data() {
    return {
      className: 'app__product__list__item',
    };
  },
  computed: {
    linkClassName() {
      return `${this.className}__link`;
    },
    imageClassName() {
      return `${this.className}__image`;
    },
    contentClassName() {
      return `${this.className}__content`;
    },
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    imageLink: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
};
